(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ea-cart-editor"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ea-cart-editor')) {
    const drafts = new Map();
    let saving = false;
    let checkoutLocks = [];
    const editors = () => [...document.querySelectorAll('ea-cart-editor')];
    const firstDirty = () => editors().find((editor) => editor.isDirty?.());
    const block = (event, editor, message) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (editor) {
        editor.querySelector('details').open = true;
        editor.message(message || editor.dataset.dirtyMessage, true);
        editor.querySelector('[data-save]').focus();
      }
    };
    const lock = (value) => {
      saving = value;
      const items = document.getElementById('main-cart-items');
      if (items) items.inert = value;
      document.querySelectorAll('.additional-checkout-buttons').forEach((element) => { element.inert = value || Boolean(firstDirty()); });
      if (value) {
        checkoutLocks = [...document.querySelectorAll('[name="checkout"]')].map((element) => [element, element.disabled]);
        checkoutLocks.forEach(([element]) => { element.disabled = true; });
      } else {
        checkoutLocks.forEach(([element, disabled]) => { if (element.isConnected) element.disabled = disabled; });
        checkoutLocks = [];
      }
    };
    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      const checkout = target.closest('[name="checkout"], a[href*="/checkout"], .additional-checkout-buttons');
      const quantity = target.closest('#main-cart-items quantity-input button, #main-cart-items cart-remove-button');
      const dirty = firstDirty();
      if ((checkout || quantity) && (saving || dirty)) block(event, dirty, saving ? dirty?.dataset.savingMessage : undefined);
    }, true);
    document.addEventListener('submit', (event) => {
      if (event.target.id === 'ea-cart-property-fields') { event.preventDefault(); return; }
      if (event.target.id !== 'cart') return;
      const dirty = firstDirty();
      if (saving || dirty) block(event, dirty, saving ? dirty?.dataset.savingMessage : undefined);
    }, true);
    document.addEventListener('change', (event) => {
      if (!event.target.matches('#main-cart-items input[name="updates[]"]')) return;
      const dirty = firstDirty();
      if (saving || dirty) {
        event.target.value = event.target.defaultValue;
        block(event, dirty);
      }
    }, true);
    window.addEventListener('beforeunload', (event) => {
      if (saving || firstDirty()) { event.preventDefault(); event.returnValue = ''; }
    });
    customElements.define('ea-cart-editor', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.fields = [...this.querySelectorAll('[data-property]')];
        this.original = this.values();
        const draft = drafts.get(this.dataset.key);
        if (draft) {
          this.fields.forEach((input) => { if (Object.hasOwn(draft, input.dataset.property)) input.value = draft[input.dataset.property]; });
          this.querySelector('details').open = true;
          this.updateDirty();
        }
        this.addEventListener('input', () => this.updateDirty());
        this.addEventListener('change', (event) => event.stopPropagation());
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' && event.target.matches('[data-property]')) { event.preventDefault(); this.save(); }
        });
        this.querySelector('[data-save]').addEventListener('click', () => this.save());
        this.querySelector('[data-reset]').addEventListener('click', () => {
          this.fields.forEach((input) => { input.value = this.original[input.dataset.property]; });
          this.updateDirty();
          this.message('');
        });
      }
      values() { return Object.fromEntries(this.fields.map((input) => [input.dataset.property, input.value])); }
      isDirty() { return this.fields?.some((input) => input.value !== this.original[input.dataset.property]); }
      updateDirty() {
        const dirty = this.isDirty();
        this.querySelector('[data-save]').disabled = !dirty;
        this.querySelector('[data-reset]').disabled = !dirty;
        if (dirty) drafts.set(this.dataset.key, this.values());
        else drafts.delete(this.dataset.key);
        document.querySelectorAll('.additional-checkout-buttons').forEach((element) => { element.inert = saving || Boolean(firstDirty()); });
        this.message(dirty ? this.dataset.dirtyMessage : '');
      }
      message(text, error = false) {
        const status = this.querySelector('[data-status]');
        status.textContent = text;
        status.dataset.error = String(error);
      }
      async save() {
        if (saving || !this.isDirty()) return;
        const invalid = this.fields.find((input) => !input.checkValidity());
        if (invalid) { invalid.reportValidity(); return; }
        const nativePending = document.querySelector('#main-cart-items.cart__items--disabled') || [...document.querySelectorAll('#main-cart-items input[name="updates[]"]')].some((input) => input.value !== input.defaultValue);
        if (nativePending) { this.message(this.dataset.waitMessage, true); return; }
        const values = this.values();
        const oldKey = this.dataset.key;
        const oldIndex = editors().indexOf(this);
        const parts = [
          { id: 'main-cart-items', section: document.getElementById('main-cart-items')?.dataset.id, selector: '.js-contents' },
          { id: 'main-cart-footer', section: document.getElementById('main-cart-footer')?.dataset.id, selector: '.js-contents' },
          { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
        ].filter((part) => part.section && document.getElementById(part.id));
        lock(true);
        this.message(this.dataset.savingMessage);
        try {
          const response = await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
          if (!response.ok) throw new Error(this.dataset.errorMessage);
          const cart = await response.json();
          const current = cart.items.find((item) => item.key === oldKey);
          if (!current) throw new Error(this.dataset.refreshMessage);
          const properties = { ...current.properties, ...values };
          // Modell lagret: fjern «Trenger hjelp». Tomt felt: samme som «Jeg vet ikke modellen» på produktsiden (Fable 11.10, funn 3).
          const modell = String(properties.Utstyr || '').trim();
          if (!modell || modell === this.dataset.modelUnknown) {
            properties.Utstyr = this.dataset.modelUnknown;
            properties['Trenger hjelp'] = this.dataset.helpValue;
          } else {
            delete properties['Trenger hjelp'];
          }
          if (!String(properties.Merknad || '').trim()) delete properties.Merknad;
          const savedResponse = await fetch(this.dataset.changeUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: oldKey, quantity: current.quantity, properties, sections: parts.map((part) => part.section), sections_url: window.location.pathname })
          });
          const saved = await savedResponse.json();
          if (!savedResponse.ok || saved.errors || saved.status >= 400) throw new Error(this.dataset.errorMessage);
          const fragments = parts.map((part) => {
            const html = saved.sections?.[part.section];
            const source = html && new DOMParser().parseFromString(html, 'text/html').querySelector(part.selector);
            if (!source) throw new Error(this.dataset.refreshMessage);
            return { ...part, html: source.innerHTML };
          });
          drafts.delete(oldKey);
          fragments.forEach((part) => {
            const target = document.getElementById(part.id);
            const contents = target.querySelector(part.selector) || target;
            contents.innerHTML = part.html;
          });
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: saved });
          const next = editors()[Math.min(oldIndex, editors().length - 1)];
          if (next && !next.isDirty()) {
            next.querySelector('details').open = true;
            next.message(next.dataset.savedMessage);
            next.querySelector('summary').focus();
          }
        } catch (error) {
          this.message(error.message || this.dataset.errorMessage, true);
        } finally {
          lock(false);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ea-cart-sticky"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ea-cart-sticky')) {
    customElements.define('ea-cart-sticky', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-ea-cart-checkout]');
        this.sum = this.querySelector('[data-ea-cart-sum]');
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.check();
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        const footer = document.getElementById('main-cart-footer');
        if (footer && window.MutationObserver) {
          this.observer = new MutationObserver(this.onScroll);
          this.observer.observe(footer, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'disabled', 'inert'] });
        }
        this.check();
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        if (this.observer) this.observer.disconnect();
        document.body.classList.remove('ea-cart-sticky-active');
      }
      check() {
        const main = document.getElementById('checkout');
        const footer = document.getElementById('main-cart-footer');
        const empty = !footer || footer.classList.contains('is-empty');
        let show = false;
        if (main && !empty && main.offsetParent !== null) {
          const r = main.getBoundingClientRect();
          show = !(r.bottom > 0 && r.top < window.innerHeight);
        }
        if (show) {
          const total = document.querySelector('#main-cart-footer .totals__total-value');
          if (total && this.sum) this.sum.textContent = total.textContent.trim();
          if (this.button) this.button.disabled = main.disabled;
        }
        if (show === !this.hidden) return;
        this.hidden = !show;
        document.body.classList.toggle('ea-cart-sticky-active', show);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ea-product-bolt-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ea-bolt-guide')) {
    customElements.define('ea-bolt-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.search = this.querySelector('[data-ea-bolt-search]');
        this.results = this.querySelector('[data-ea-bolt-results]');
        this.missing = this.querySelector('[data-ea-bolt-missing]');
        this.rows = Array.from(this.querySelectorAll('table tbody tr'));
        this.links = this.querySelectorAll('[data-ea-guide-product-link]');
        this.filter = () => {
          const query = this.search.value.trim().toLocaleLowerCase().replace(/\s+/g, ' ');
          let count = 0;
          this.rows.forEach(row => {
            const rowText = row.textContent.toLocaleLowerCase().replace(/\s+/g, ' ');
            const matches = !query || query.split(' ').every(word => rowText.includes(word));
            row.hidden = !matches;
            if (matches) count++;
          });
          this.results.textContent = query ? this.dataset.resultsTemplate.replace('{count}', count).replace('{total}', this.rows.length) : '';
          this.missing.hidden = !query || count > 0;
          this.links.forEach(link => {
            const url = new URL(link.href, window.location.origin);
            if (this.search.value.trim()) url.searchParams.set('ea_model', this.search.value.trim());
            else url.searchParams.delete('ea_model');
            link.href = url.toString();
          });
        };
        this.search.value = (new URL(window.location.href).searchParams.get('ea_model') || '').slice(0, 240);
        this.search.addEventListener('input', this.filter);
        this.filter();
      }
      disconnectedCallback() {
        this.search?.removeEventListener('input', this.filter);
        this.initialized = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ea-product-setup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ea-product-setup')) {
    customElements.define('ea-product-setup', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.closest('form');
        this.model = this.querySelector('[data-ea-equipment]');
        this.note = this.querySelector('[data-ea-note]');
        this.help = this.querySelector('[data-ea-need-help]');
        this.error = this.querySelector('[data-ea-error]');
        if (!this.form || !this.model || !this.note || !this.help) return;
        this.storageKey = 'ea-product-setup:' + this.dataset.storageGroup;
        let saved = {};
        try { saved = JSON.parse(sessionStorage.getItem(this.storageKey) || '{}'); } catch (_) {}
        if (!saved || typeof saved !== 'object') saved = {};
        const normalizeModel = value => String(value || '').normalize('NFKC').trim().replace(/\s+/g, ' ').toLowerCase();
        const currentUrl = new URL(window.location.href);
        const incoming = currentUrl.searchParams.get('ea_model');
        const savedModel = typeof saved.model === 'string' ? saved.model : '';
        const sameModel = incoming === null || normalizeModel(incoming) === normalizeModel(savedModel);
        this.model.value = (incoming !== null ? incoming : savedModel).slice(0, 240);
        this.note.value = sameModel && typeof saved.note === 'string' ? saved.note.slice(0, 240) : '';
        // Avkrysningen «Jeg vet ikke modellen» huskes ikke mellom produkter (Fable 11.10, funn 3).
        this.help.checked = false;
        if (incoming !== null) {
          currentUrl.searchParams.delete('ea_model');
          window.history.replaceState(window.history.state, '', currentUrl.toString());
        }
        const describedBy = this.model.getAttribute('aria-describedby') || '';
        this.clearError = () => {
          if (this.error) this.error.hidden = true;
          this.model.removeAttribute('aria-invalid');
          this.model.setAttribute('aria-describedby', describedBy);
        };
        this.showError = () => {
          if (!this.error) return;
          this.error.hidden = false;
          this.model.setAttribute('aria-invalid', 'true');
          this.model.setAttribute('aria-describedby', (describedBy + ' ' + this.error.id).trim());
          // Rull rett til feltet uten animasjon. Den myke rullingen ble avbrutt på mobil når den klebrige
          // kjøpsknappen ble brukt, og feltet havnet over skjermkanten (Fable-auditen 12.10, A1 #3).
          const header = document.querySelector('.section-header');
          const label = this.querySelector('label[for="' + this.model.id + '"]') || this.model;
          const top = label.getBoundingClientRect().top + window.scrollY - (header ? header.offsetHeight : 0) - 16;
          const html = document.documentElement;
          const before = html.style.scrollBehavior;
          html.style.scrollBehavior = 'auto';
          window.scrollTo(0, Math.max(0, top));
          html.style.scrollBehavior = before;
          this.model.focus({ preventScroll: true });
        };
        this.update = (event) => {
          // Feltet og avkrysningen utelukker hverandre (Fable 11.10, funn 3).
          const kilde = event && event.target;
          if (kilde === this.model && this.model.value.trim()) this.help.checked = false;
          if (kilde === this.help && this.help.checked) this.model.value = '';
          this.model.setAttribute('aria-required', this.help.checked ? 'false' : 'true');
          this.model.setCustomValidity('');
          if (this.model.value.trim() || this.help.checked) this.clearError();
          try {
            sessionStorage.setItem(this.storageKey, JSON.stringify({ model: this.model.value, note: this.note.value }));
          } catch (_) {}
          const scope = this.closest('product-info') || document;
          scope.querySelectorAll('[data-ea-finish-link], [data-ea-guide-link]').forEach(link => {
            const url = new URL(link.href, window.location.origin);
            if (this.model.value.trim()) url.searchParams.set('ea_model', this.model.value.trim());
            else url.searchParams.delete('ea_model');
            link.href = url.toString();
          });
        };
        this.addEventListener('input', this.update);
        this.addEventListener('change', this.update);
        this.serialize = event => {
          if (!this.model.value.trim()) event.formData.set('properties[Utstyr]', this.dataset.modelUnknown);
          if (!this.note.value.trim()) event.formData.delete('properties[Merknad]');
        };
        this.form.addEventListener('formdata', this.serialize);
        // Fangstfasen på document kommer før product-form.js, som sender uten å sjekke (skjemaet har novalidate).
        this.guard = event => {
          if (event.target !== this.form) return;
          if (this.model.value.trim() || this.help.checked) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.showError();
        };
        document.addEventListener('submit', this.guard, true);
        this.update();
      }
      disconnectedCallback() {
        this.form?.removeEventListener('formdata', this.serialize);
        document.removeEventListener('submit', this.guard, true);
        this.removeEventListener('input', this.update);
        this.removeEventListener('change', this.update);
        this.initialized = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
